import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { serverFetch } from "../../server";
import { message, Table } from "antd";
import { getSaleStatusTag } from "../../extensions/helper";
import { fmtDate } from "../../extensions/utils";
import { isMobile } from "../../extensions/design";
import VisitClientAbonItem from "./visit-client-abon-item";

// Отображение абонементов клиента для выбора
const VisitsClientAbons = forwardRef(({ clientId, onSelect, saleId }, ref) => {
  const [items, setItems] = useState([]); // Абонементы клиента
  const divRef = useRef(null);

  const getItems = () => {
    serverFetch(`sale/ListByClient/${clientId}?vids=2`)
      .then(data => setItems(data.filter(i => i.status !== 5 && ! i.deleted)))
      .catch(e => message.error(e.userMessage))
  };

  useEffect(() => getItems(), [clientId])

  useImperativeHandle(ref, () => ({ getItems }));

  const colAbons = [
    { dataIndex: "id", title: "#", width: 50 },
    { dataIndex: "productName", title: "Выберите абонемент" },
    { title: "Срок", width: 100, dataIndex: "finish", render: fmtDate, align: "center" },
    { dataIndex: "status", title: "Статус", render : getSaleStatusTag, width: 100  },
    { title: "Долг", width: 100, dataIndex: "debet", align: "right" },
  ]

  const headerSize =  divRef.current?.querySelector('.ant-table-thead')?.offsetHeight ?? 0;
  const tableHeight = (divRef.current ? (document.documentElement.offsetHeight - headerSize - divRef.current.getBoundingClientRect().top - window.scrollY) : 0) - 128;
  
  return<div className="sport-section visit-client-abons" ref={divRef}>
    {isMobile ? items.map(i => <VisitClientAbonItem item={i} key={i.id} selected={i.id === saleId} onSelect={onSelect}/>) : 
    <Table 
      dataSource={items}
      columns={colAbons}
      size="small"
      rowKey="id"
      pagination={false}
      scroll={{ y: tableHeight }}
      onRow={(record) => ({onClick: () => {onSelect(record)}})}
      rowSelection={{
          type: 'radio', selectedRowKeys: [saleId], renderCell: checked => <div className={checked ? "list-indicator" : ""} />
      }}
    />}
  </div>
});

export default VisitsClientAbons;